export const ON_CODES_MOUNT = '@codes/ON_CODES_MOUNT';
export const ON_CODES_MOUNT_ERROR = '@codes/ON_CODES_MOUNT_ERROR';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';
export const ON_SHOW_LOADING_STATE = 'ON_SHOW_LOADING_STATE';
export const REPORTS_DOWNLOAD_DISCOUNT_REPORT = 'REPORTS_DOWNLOAD_DISCOUNT_REPORT';
export const REPORTS_DOWNLOAD_DISCOUNT_REPORT_SUCCESS = 'REPORTS_DOWNLOAD_DISCOUNT_REPORT_SUCCESS';
export const REPORTS_DOWNLOAD_QUICK_REPORT = 'REPORTS_DOWNLOAD_QUICK_REPORT';
export const OPEN_LARGE_REPORT_EMAIL_MODAL = 'OPEN_LARGE_REPORT_EMAIL_MODAL';
export const ON_REPORTS_DOWNLOAD_ERROR = 'ON_REPORTS_DOWNLOAD_ERROR';
export const REPORTS_DOWNLOAD_DISCOUNT_REPORT_ERROR = 'REPORTS_DOWNLOAD_DISCOUNT_REPORT_ERROR';

export const onCodesMount = () => ({ type: ON_CODES_MOUNT });

export const showFlashMessage = (level, message) => ({
  type: ADD_FLASH_MESSAGE,
  payload: {
    level,
    message
  }
});

export const clearFlashMessage = () => ({
  type: CLEAR_FLASH_MESSAGE
});

export const onUpdateSearchText = (value) => ({
  type: UPDATE_SEARCH_TEXT,
  payload: value
});

export const onShowLoadingState = () => ({
  type: ON_SHOW_LOADING_STATE
});

export const downloadQuickReport = () => ({
  type: REPORTS_DOWNLOAD_DISCOUNT_REPORT
});



// WEBPACK FOOTER //
// ./src/modules/codes/actions.js